module.exports = __webpack_public_path__ + "img/banner.108fc597.png";